import { PetalProps } from "../../interfaces";
import { PetalBox, PetalsContainer } from "./style";
export const Petal: React.FC<PetalProps> = ({ degrees, color, heigth, stroke, isMobile }) => {
  return (
    <PetalBox isMobile={isMobile} degrees={degrees} stroke={stroke} color={color} >
      <PetalsContainer degrees={degrees} color={color} heigth={heigth} />
    </PetalBox>
  );
};